<template>
  <div class="w-100">
    <grid-component
        isResizable
        isReorderable
        :canEdit="checkClaim(CAN_EDIT_WORK_ORDER)"
        :canDelete="checkClaim(CAN_DELETE_WORK_ORDERS)"
        :gridId="gridId"
        :itemData="itemData"
        :fields="fields"
        :onEdit="onEdit"
        :onDelete="onDelete"
        :handleRowClick="onRowClick"
        :navigationField="'serviceOrderId'"
        :styleCustom="'height: 160px'"
      />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import debounce from 'lodash/debounce';

import { SORT_ORDER, GRID_ID } from '@/shared/constants';
import GridComponent from '@/shared/components/GridComponent';
import gridFields from './fields';

export default {
  components: {
    GridComponent,
  },
  props: {
    purchaseOrderLineId: {
      type:  [Number, String],
      default: 0,
    },
    partId: {
      type: [String, Number],
      default: 0,
    },
    isPartTab: {
      type: Boolean,
      default: false
    },
},
  data: () => ({
    selectedRowItemId: 0,
    gridId: GRID_ID.SERVICE_ORDER_LINES_TAB,
    fields: gridFields,
    checkedRowItemIds: [],
  }),
  computed: {
    ...mapGetters('serviceOrderLines', ['serviceOrderLineByPoLine', 'serviceOrderLineByPart']),
    itemData() {
      let item = [];
      if(this.isPartTab){
        item = (this.serviceOrderLineByPart) ? this.serviceOrderLineByPart : [];
      }else {
        item = (this.purchaseOrderLineId) ? this.serviceOrderLineByPoLine : [];
      }

      return item.map((serviceOrderLine) => ({ ...serviceOrderLine, selected: serviceOrderLine.id === this.selectedRowItemId }));
    },
  },
  methods: {
    ...mapActions('serviceOrderLines', [
      'getByServiceOrderId',
      'deleteServiceOrderLine',
      'getByPurchaseOrderLineId',
      'getServiceOrderLinesByPart'
    ]),
    // ...mapMutations('serviceOrderLines', ['setLastOpenedId','clearServiceOrderLines']),
    ...mapMutations('serviceOrderLines', { setserviceOrderLineItem: 'setItem'} ),
    onRowClick(row) {
      this.selectedRowItemId = row.dataItem.id;
      // this.setLastOpenedId(row.dataItem.id)
      this.setserviceOrderLineItem({ resource: 'lastOpenedId', payload: row.dataItem.id })
      // this.$bvModal.show("edit-service-order-line")
    },
    onAfterSave() {
      this.$emit('onAfterSave');
    },
    onEdit(row) {
      /*this.setLastOpenedId(row.serviceOrderId);*/
      this.setserviceOrderLineItem({ resource: 'lastOpenedId', payload: row.serviceOrderId })

      this.$router.push({
        name: 'serviceorders.edit',
        params: { id: row.serviceOrderId },
      });
    },
    async onDelete({id,serviceOrderId}) {
      const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete work order line with id :${id}?`});
      if (deleteConfirmed) {
        const result = await this.deleteServiceOrderLine({id,serviceOrderId});
        this.getData();
      }
    },
    async getData() {
      if(this.isPartTab && this.partId){
        await this.getServiceOrderLinesByPart(this.partId);
      } else if (this.purchaseOrderLineId) {
        await this.getByPurchaseOrderLineId(this.purchaseOrderLineId);
      }
    }
  },
  watch: {
    purchaseOrderLineId() {
      this.getData();
    },
    partId() {
      this.getData();
    },
  },
  mounted() {
    if(this.purchaseOrderLineId || (this.isPartTab && this.partId)){
      this.getData();
    }
  },
};
</script>

<style scoped>
.service-order-lines-grid {
  height: 185px !important;
}
</style>
